import * as React from "react";
import { forwardRef } from "react";
const SvgSelectDropdownIndicator = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 5, viewBox: "0 0 10 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 5L0.669873 0.5L9.33013 0.500001L5 5Z", fill: "#AEAEAE" }));
const ForwardRef = forwardRef(SvgSelectDropdownIndicator);
export { ForwardRef as ReactComponent };
